export default __webpack_public_path__ + "static/mobile-trans-f758ee8b6d94167ed3d5aaff81c4ef29.png";